import { InventoryState } from 'services/types';
import { createReducer } from '@reduxjs/toolkit';
import * as Actions from 'actions/InventoryActions';
import { setError, setFulfilled, setLoading } from 'services/utils/redux';

const INITIAL_STATE: InventoryState = {
	skuItems: {
		loading: true,
		error: null,
		data: null,
	},
	inventoryItems: {
		loading: true,
		error: null,
		data: null,
	},
	configuration: {
		loading: true,
		error: null,
		data: null,
	},
};

const InventoryReducer = createReducer(INITIAL_STATE, (builder) => {
	builder
		.addCase(Actions.setSkuItemsListener.pending, (state) => {
			if (!state.skuItems.data?.length) {
				setLoading(state.skuItems);
			}
		})
		.addCase(Actions.setSkuItemsError, (state, action) => {
			setError(state.skuItems, { error: action.payload });
		})
		.addCase(Actions.setSkuItemsData, (state, action) => {
			setFulfilled(state.skuItems, { data: action.payload });
		});

	builder
		.addCase(Actions.setInventoryItemsListener.pending, (state) => {
			if (!state.inventoryItems.data?.length) {
				setLoading(state.inventoryItems);
			}
		})
		.addCase(Actions.setInventoryItemsError, (state, action) => {
			setError(state.inventoryItems, { error: action.payload });
		})
		.addCase(Actions.setInventoryItemsData, (state, action) => {
			setFulfilled(state.inventoryItems, { data: action.payload });
		});

	builder
		.addCase(Actions.setInventoryConfigurationListener.pending, (state) => {
			if (!state.configuration.data) {
				setLoading(state.configuration);
			}
		})
		.addCase(Actions.setInventoryConfigurationError, (state, action) => {
			setError(state.configuration, { error: action.payload });
		})
		.addCase(Actions.setInventoryConfigurationData, (state, action) => {
			setFulfilled(state.configuration, { data: action.payload });
		});
});

export default InventoryReducer;
